import { TermsType } from '@/hooks/shared/termsConfig';
import useGetTerms from '@/hooks/shared/useGetTerms';
import { useMediaQuery } from '@/hooks/shared/useMediaQuery';

import CkEditorContent from '@/components/apps/ui/ckEditorContent/CkEditorContent';

import Modal from './modal';
import type { ModalType } from './types';

type Props = {
  id: string;
  size?: ModalType['size'];
  termsType: TermsType;
  closeOnClickOutside: boolean;
  /** size가 full이 아니어도 모바일에서 full 반응형 처리 옵션 */
  isResponsive: boolean;
  modalSubmit: () => void;
  modalClose: () => void;
};

export default function TermsModal({
  id,
  size = 'sm',
  termsType,
  closeOnClickOutside,
  isResponsive = false,
  modalClose,
}: Props) {
  const { modalTitle, replaceContent } = useGetTerms({ termsType: termsType });
  const isDesktop = useMediaQuery({
    query: '(min-width: 992px)',
  });

  // 반응형 코드 추가
  const modalSize = isResponsive ? (isDesktop ? size : 'full') : size;

  return (
    <>
      <Modal.Overlay id={id} closeOnClickOutside={closeOnClickOutside} />
      <Modal size={modalSize}>
        <Modal.Header title={modalTitle} onClose={modalClose} />

        <Modal.Body size={modalSize}>
          <CkEditorContent
            content={replaceContent}
            className="border-none py-0 lg:py-0"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
